import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FiPlus, FiInbox, FiEdit2, FiTrash2, FiCalendar, FiAward, FiChevronDown, FiChevronUp, FiAlertTriangle, FiCheck, FiFilter, FiEye } from 'react-icons/fi';
import { db, auth } from '../../firebase';
import { collection, query, where, onSnapshot, doc, deleteDoc, addDoc, serverTimestamp, writeBatch, getDoc, updateDoc, setDoc } from 'firebase/firestore'; // JAVÍTVA: updateDoc és setDoc hozzáadva
import * as XLSX from 'xlsx'; // ÚJ: Excel beolvasó könyvtár

const actionButtonStyle = (bg, color, border) => ({
  width: '100%',
  padding: '10px',
  backgroundColor: bg,
  color: color,
  border: `1px solid ${border}`,
  borderRadius: '8px',
  fontWeight: 'bold',
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '8px',
  fontSize: '0.85rem',
  transition: '0.2s'
});

// --- ÚJ: KATEGÓRIA ÁTNEVEZÉSI TÁBLÁZAT ---
const CATEGORY_ALIASES = {
  'tradi': 'Történelmi íj',
  'vadaszij karbon vesszovel': 'Vadászíj karbonvesszővel',
  'vadaszij karbon vesszővel': 'Vadászíj karbonvesszővel',
  'vadaszij fa vesszovel': 'Vadászíj fa vesszővel',
  'vadaszij fa vesszővel': 'Vadászíj fa vesszővel'
};

const normalizeForAlias = (str) => {
  return (str || "").toString().toLowerCase().trim()
    .normalize("NFD").replace(/[\u0300-\u036f]/g, ""); // Ékezetek leszedése az összehasonlításhoz
};

const getOfficialCategoryName = (excelCat) => {
  const clean = normalizeForAlias(excelCat);
  // Megnézzük a pontos magyar ékezetes formát és az ékezet nélkülit is
  if (CATEGORY_ALIASES[clean]) return CATEGORY_ALIASES[clean];
  if (CATEGORY_ALIASES[excelCat.toLowerCase().trim()]) return CATEGORY_ALIASES[excelCat.toLowerCase().trim()];
  return excelCat; // Ha nincs a listában, marad az eredeti
};

const Tournaments = () => {
  const navigate = useNavigate();
  const [tournaments, setTournaments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [expandedTournamentId, setExpandedTournamentId] = useState(null);
  const [isSendingInvite, setIsSendingInvite] = useState(false); // ÚJ: Meghívó küldés állapota

  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [tournamentToDelete, setTournamentToDelete] = useState(null);
  const [selectedRoundOrgs, setSelectedRoundOrgs] = useState({}); // Melyik fordulóhoz melyik org van kiválasztva
  const [localPending, setLocalPending] = useState([]); // ÚJ: Meghívók állapota (Legfelső szinten)
  const [showEventPicker, setShowEventPicker] = useState(false); // ÚJ: Versenyválasztó modal
  const [pickingFor, setPickingFor] = useState(null); // { tournament, roundIndex }

  // --- ÚJ: EXCEL IMPORT ÁLLAPOTOK ---
  const [showImportModal, setShowImportModal] = useState(false);
  const [importStep, setImportStep] = useState(1); // 1: Feltöltés, 2: Párosítás/Összesítő
  const [excelHeaders, setExcelHeaders] = useState([]);
  const [excelRows, setExcelRows] = useState([]);
  const [columnMapping, setColumnMapping] = useState({
    name: '',
    license: '',
    category: '',
    age: '',
    gender: '',
    points: ''
  });
  const [importingFor, setImportingFor] = useState(null); // { tournament, roundIndex }
  const [isProcessingExcel, setIsProcessingExcel] = useState(false);
  const [autoMatchFound, setAutoMatchFound] = useState(false);
  const [showViewModal, setShowViewModal] = useState(false);
  const [viewingResults, setViewingResults] = useState([]);
  const [isFetchingResults, setIsFetchingResults] = useState(false);

  // --- ÚJ: ÉRTESÍTÉSEK FIGYELÉSE ---

  useEffect(() => {
    if (!auth.currentUser) return;
    const uq = query(collection(db, "notifications"), where("toUserId", "==", auth.currentUser.uid), where("status", "==", "unread"));
    const unsub = onSnapshot(uq, (snap) => setLocalPending(snap.docs.map(d => ({id: d.id, ...d.data()}))));
    return () => unsub();
  }, []);

  // --- ÚJ: EXCEL FÁJL BEOLVASÁSA ---
  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setIsProcessingExcel(true);
    const reader = new FileReader();
    reader.onload = (evt) => {
      try {
        const bstr = evt.target.result;
        const wb = XLSX.read(bstr, { type: 'binary' });
        const wsname = wb.SheetNames[0];
        const ws = wb.Sheets[wsname];
        const data = XLSX.utils.sheet_to_json(ws, { header: 1 });

        if (data.length > 0) {
          const headers = data[0].map(h => String(h || "").trim());
          const rawRows = data.slice(1);

          // Intelligens auto-párosítás
          const newMapping = { name: '', license: '', category: '', age: '', gender: '', points: '' };
          let foundMandatory = 0;

          headers.forEach((h, idx) => {
            const head = h.toLowerCase();
            if (head.includes('név') || head === 'name') { newMapping.name = idx; foundMandatory++; }
            if (head.includes('eng') || head.includes('licen')) newMapping.license = idx;
            if (head.includes('kateg') || head.includes('categ')) newMapping.category = idx;
            if (head.includes('kor') || head.includes('age')) newMapping.age = idx;
            if (head.includes('nem') || head.includes('gend')) newMapping.gender = idx;
            if (head.includes('pont') || head.includes('score')) { newMapping.points = idx; foundMandatory++; }
          });

          // JAVÍTÁS: Csak azokat a sorokat tartjuk meg, ahol a NÉV oszlop nem üres
          const filteredRows = rawRows.filter(row => {
            const nameVal = newMapping.name !== '' ? row[newMapping.name] : null;
            return nameVal && String(nameVal).trim() !== "";
          });

          setExcelHeaders(headers);
          setExcelRows(filteredRows);
          setColumnMapping(newMapping);

          // Ha megtaláltuk a Nevet és a Pontot, vagy ez egy ArcheryNexus Export (Hely. és Összpontszám alapján)
          const isArcheryNexusExport = headers.includes("Hely.") && headers.includes("Összpontszám");
          setAutoMatchFound(foundMandatory >= 2 || isArcheryNexusExport);
          setImportStep(2);
        }
      } catch (err) {
        console.error("Excel beolvasási hiba:", err);
        alert("Hiba történt a fájl beolvasásakor!");
      } finally {
        setIsProcessingExcel(false);
      }
    };
    reader.readAsBinaryString(file);
  };

  // --- ÚJ: IMPORTÁLT ADATOK MENTÉSE ---
  const handleSaveImport = async () => {
    // ArcheryNexus Export detektálása (Hely. és Összpontszám oszlopok jelenléte)
    const isArcheryNexusExport = excelHeaders.includes("Hely.") && excelHeaders.includes("Összpontszám");

    if (!isArcheryNexusExport && (columnMapping.name === '' || columnMapping.points === '')) {
      alert("A Név és a Pontok oszlop megadása kötelező!");
      return;
    }

    try {
      let results = [];

      if (isArcheryNexusExport) {
        // --- SPECIÁLIS LOGIKA AZ ARCHERYNEXUS EXPORTÁLT EXCELHEZ ---
        let currentCategory = "";
        let currentAge = "";
        let currentGender = "";

        excelRows.forEach(row => {
          const firstCell = String(row[0] || "").trim();

          // Ha a sor egy kategória fejléc (pl. "Tradi - Felnőtt - Férfi")
          if (firstCell && firstCell.includes(" - ")) {
            const parts = firstCell.split(" - ");
            currentCategory = parts[0] || "";
            currentAge = parts[1] || "";
            currentGender = parts[2] || "";
          }
          // Ha a sor egy adat (kezdődik helyezéssel, pl. "1.")
          else if (firstCell && firstCell.endsWith(".")) {
            results.push({
              name: row[1] || "", // Név oszlop
              license: "", // Az exportban sajnos nincs benne az engedélyszám alapból
              category: getOfficialCategoryName(currentCategory),
              ageGroup: currentAge,
              gender: currentGender,
              points: Number(row[excelHeaders.indexOf("Összpontszám")]) || 0
            });
          }
        });
      } else {
        // --- NORMÁL LAPOS TÁBLÁZAT LOGIKA ---
        results = excelRows.map(row => ({
          name: row[columnMapping.name] || "",
          license: columnMapping.license !== '' ? row[columnMapping.license] || "" : "",
          category: getOfficialCategoryName(row[columnMapping.category] || ""),
          ageGroup: columnMapping.age !== '' ? row[columnMapping.age] || "" : "",
          gender: columnMapping.gender !== '' ? row[columnMapping.gender] || "" : "",
          points: columnMapping.points !== '' ? Number(row[columnMapping.points]) || 0 : 0
        })).filter(p => p.name); // Üres sorok kiszűrése
      }

      if (results.length === 0) {
        alert("Nem találtam feldolgozható eredményt a fájlban!");
        return;
      }

      const tRef = doc(db, "tournaments", importingFor.tournament.id);
      const resultsRef = doc(db, "tournaments", importingFor.tournament.id, "importedResults", `round_${importingFor.roundIndex}`);

      await updateDoc(resultsRef, {
        results: results,
        importedAt: serverTimestamp(),
        roundIndex: importingFor.roundIndex,
        source: "excel"
      }).catch(async (err) => {
        // Ha nem létezik a dokumentum, létrehozzuk setDoc-kal
        await setDoc(resultsRef, {
          results: results,
          importedAt: serverTimestamp(),
          roundIndex: importingFor.roundIndex,
          source: "excel"
        });
      });

      // Jelezzük a kupa dokumentumban is, hogy ez egy importált forduló
      const newRounds = [...(importingFor.tournament.rounds || [])];
      if (!newRounds[importingFor.roundIndex]) {
        newRounds[importingFor.roundIndex] = { roundIndex: importingFor.roundIndex, organizerId: auth.currentUser.uid, eventId: null, isImported: true };
      } else {
        newRounds[importingFor.roundIndex].isImported = true;
      }
      await updateDoc(tRef, { rounds: newRounds });

      alert(`Sikeresen importálva ${results.length} eredmény! 🏹✅`);
      setShowImportModal(false);
      setImportStep(1);
    } catch (error) {
      console.error("Hiba a mentéskor:", error);
      alert("Nem sikerült elmenteni az eredményeket.");
    }
  };

  // --- ÚJ: IMPORTÁLT EREDMÉNYEK TÖRLÉSE ---
  const handleRemoveImport = async (tournament, roundIndex) => {
    if (!window.confirm("Biztosan törlöd az importált eredményeket ebből a fordulóból?")) return;
    try {
      const tRef = doc(db, "tournaments", tournament.id);
      const resultsRef = doc(db, "tournaments", tournament.id, "importedResults", `round_${roundIndex}`);

      await deleteDoc(resultsRef);

      const newRounds = [...(tournament.rounds || [])];
      if (newRounds[roundIndex]) {
        newRounds[roundIndex].isImported = false;
        await updateDoc(tRef, { rounds: newRounds });
      }
    } catch (error) {
      console.error("Hiba a törléskor:", error);
    }
  };

  // --- ÚJ: IMPORTÁLT EREDMÉNYEK MEGTEKINTÉSE ---
  const handleViewImport = async (tournament, roundIndex) => {
    setIsFetchingResults(true);
    setViewingResults([]);
    setShowViewModal(true);
    try {
      const resultsRef = doc(db, "tournaments", tournament.id, "importedResults", `round_${roundIndex}`);
      const resSnap = await getDoc(resultsRef);
      if (resSnap.exists()) {
        setViewingResults(resSnap.data().results || []);
      }
    } catch (error) {
      console.error("Hiba az adatok lekérésekor:", error);
    } finally {
      setIsFetchingResults(false);
    }
  };

  // --- ÚJ: ÉRTESÍTÉSEK KÜLDÉSE A SZERVEZŐKNEK ---
  const sendTournamentNotifications = async (tournament, type, extraData = {}) => {
    try {
      const activeOrganizers = tournament.organizers?.filter(org =>
        org.id !== auth.currentUser.uid && (org.status === 'active' || org.status === 'owner')
      ) || [];

      if (activeOrganizers.length === 0) return;

      const batch = writeBatch(db);
      activeOrganizers.forEach(org => {
        const notifRef = doc(collection(db, "notifications"));
        batch.set(notifRef, {
          toUserId: org.id,
          fromUserId: auth.currentUser.uid,
          fromUserName: tournament.organizers?.find(o => o.id === auth.currentUser.uid)?.name || "Egyik szervező",
          tournamentId: tournament.id,
          tournamentName: tournament.name,
          type: type,
          status: "unread",
          createdAt: serverTimestamp(),
          ...extraData
        });
      });
      await batch.commit();
    } catch (error) {
      console.error("Hiba az értesítések kiküldésekor:", error);
    }
  };

  const acceptInvite = async (invite) => {
    try {
      const batch = writeBatch(db); // Helyes moduláris API hívás

      // 1. Értesítés törlése (már nincs rá szükség az elfogadás után)
      batch.delete(doc(db, "notifications", invite.id));

      const tRef = doc(db, "tournaments", invite.tournamentId);
      const tSnap = await getDoc(tRef);
      if (tSnap.exists()) {
        const tData = tSnap.data();
        const updatedOrganizers = tData.organizers.map(org =>
          org.id === auth.currentUser.uid ? { ...org, status: 'active' } : org
        );
        batch.update(tRef, { organizers: updatedOrganizers });

        // --- ÚJ: ÉRTESÍTÉS A TÖBBI SZERVEZŐNEK A CSATLAKOZÁSRÓL ---
        await sendTournamentNotifications({ id: invite.tournamentId, ...tData }, "tournament_invite_accepted");
      }
      await batch.commit();

      alert(`Sikeresen csatlakoztál a(z) ${invite.tournamentName} kupasorozathoz! 🤝`);
    } catch(e) { console.error("Hiba elfogadáskor:", e); }
  };

  const rejectInvite = async (invite) => {
    try {
      const batch = writeBatch(db);

      // 1. Értesítés törlése (elutasításkor is töröljük a szemetet)
      batch.delete(doc(db, "notifications", invite.id));

      const tRef = doc(db, "tournaments", invite.tournamentId);
      const tSnap = await getDoc(tRef);
      if (tSnap.exists()) {
        const tData = tSnap.data();
        const updatedOrganizers = tData.organizers.filter(org => org.id !== auth.currentUser.uid);
        batch.update(tRef, { organizers: updatedOrganizers });
      }
      await batch.commit();
    } catch(e) { console.error("Hiba elutasításkor:", e); }
  };

  const createButtonStyle = {
    backgroundColor: '#b30000',
    color: 'white',
    border: 'none',
    padding: '8px 15px',
    borderRadius: '10px',
    fontWeight: 'bold',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    fontSize: '15px',
    transition: '0.2s',
    marginBottom: '5px'
  };

  const emptyStateStyle = {
    gridColumn: '1 / -1',
    textAlign: 'center',
    padding: '60px 20px',
    backgroundColor: '#fdfdfd',
    borderRadius: '12px',
    border: '2px dashed #eee',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center'
  };

  const accordionHeaderStyle = (isExpanded) => ({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    backgroundColor: isExpanded ? '#fff5f5' : '#fff',
    padding: '15px 20px',
    border: isExpanded ? '1px solid #ffcccc' : '1px solid #eee',
    borderRadius: isExpanded ? '12px 12px 0 0' : '12px',
    boxShadow: isExpanded ? 'none' : '0 2px 8px rgba(0,0,0,0.05)',
    cursor: 'pointer',
    transition: 'all 0.2s ease'
  });

  const accordionBodyStyle = {
    backgroundColor: '#fff',
    border: '1px solid #ffcccc',
    borderTop: 'none',
    borderRadius: '0 0 12px 12px',
    padding: '20px',
    boxShadow: '0 8px 15px rgba(179,0,0,0.05)'
  };

  const modalOverlayStyle = {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.7)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1000,
    backdropFilter: 'blur(3px)'
  };

  const modalContentStyle = {
    backgroundColor: 'white',
    padding: '30px',
    borderRadius: '15px',
    textAlign: 'center',
    maxWidth: '400px',
    width: '90%',
    boxShadow: '0 15px 35px rgba(0,0,0,0.3)'
  };

  const modalDeleteButtonStyle = {
    backgroundColor: '#b30000',
    color: 'white',
    border: 'none',
    padding: '12px 24px',
    borderRadius: '8px',
    fontWeight: 'bold',
    cursor: 'pointer'
  };

  const modalCancelButtonStyle = {
    backgroundColor: '#eee',
    color: '#333',
    border: 'none',
    padding: '12px 24px',
    borderRadius: '8px',
    fontWeight: 'bold',
    cursor: 'pointer'
  };

  const openDeleteModal = (tournament) => {
    setTournamentToDelete(tournament);
    setShowDeleteModal(true);
  };

  const handleFinalDelete = async () => {
    if (!tournamentToDelete) return;

    try {
      await deleteDoc(doc(db, "tournaments", tournamentToDelete.id));
      setTournaments(prev => prev.filter(t => t.id !== tournamentToDelete.id));
      setShowDeleteModal(false);
      setTournamentToDelete(null);
    } catch (error) {
      console.error("Hiba a törlés során:", error);
      alert("A kupasorozat törlése sikertelen!");
    }
  };

  // --- ÚJ: MEGHÍVÓ KÜLDÉSE ---
  const handleSendInvite = async (selectedOrg, tournament) => {
    if (isSendingInvite) return;

    setIsSendingInvite(true);
    try {
      // 1. Megnézzük, nincs-e már egy olvasatlan vagy elfogadott meghívó neki erre a kupára
      const q = query(
        collection(db, "notifications"),
        where("toUserId", "==", selectedOrg.id),
        where("tournamentId", "==", tournament.id),
        where("type", "==", "tournament_invite")
      );

      // Megjegyzés: ideális esetben getDocs-szal kellene, de mivel ez csak a felületről hívódik, simán beírjuk
      // Ha már van neki meghívója, sebaj, kap egy másikat emlékeztetőül (vagy a biztonsági szabályokkal levédjük).

      const inviteData = {
        toUserId: selectedOrg.id,
        fromUserId: auth.currentUser.uid, // Aki épp nyomja a gombot
        tournamentId: tournament.id,
        tournamentName: tournament.name,
        type: "tournament_invite",
        status: "unread",
        createdAt: serverTimestamp()
      };

      await addDoc(collection(db, "notifications"), inviteData);

      alert(`Meghívó sikeresen elküldve a következőnek: ${selectedOrg.name}! 🚀`);
    } catch (error) {
      console.error("Hiba a meghívó küldésekor:", error);
      alert("Nem sikerült elküldeni a meghívót!");
    } finally {
      setIsSendingInvite(false);
    }
  };

  // --- ÚJ: FORDULÓ SZERVEZŐJÉNEK MENTÉSE AZ ADATBÁZISBA ---
  const handleRoundOrganizerChange = async (tournament, roundIndex, newOrganizerId) => {
    try {
      const tRef = doc(db, "tournaments", tournament.id);

      // Másoljuk a meglévő fordulókat
      const newRounds = [...(tournament.rounds || [])];

      // Ha esetleg valamiért hiányozna az adott indexű elem, létrehozzuk
      if (!newRounds[roundIndex]) {
        newRounds[roundIndex] = { roundIndex, organizerId: newOrganizerId, eventId: null };
      } else {
        newRounds[roundIndex].organizerId = newOrganizerId; // Módosítjuk a szervezőt
      }

      // Mentjük az adatbázisba azonnal
      await updateDoc(tRef, { rounds: newRounds });

      // A UI állapot (selectedRoundOrgs) frissítése
      setSelectedRoundOrgs(prev => ({
        ...prev,
        [`${tournament.id}_${roundIndex}`]: newOrganizerId
      }));

    } catch (error) {
      console.error("Hiba a forduló szervezőjének mentésekor:", error);
    }
  };

  // --- ÚJ: VERSENY HOZZÁRENDELÉSE A FORDULÓHOZ ---
  const handleRoundEventChange = async (tournament, roundIndex, newEventId) => {
    try {
      const tRef = doc(db, "tournaments", tournament.id);
      const newRounds = [...(tournament.rounds || [])];

      if (!newRounds[roundIndex]) {
        newRounds[roundIndex] = {
          roundIndex,
          organizerId: tournament.organizers?.[0]?.id || auth.currentUser.uid,
          eventId: newEventId
        };
      } else {
        newRounds[roundIndex].eventId = newEventId;
      }

      await updateDoc(tRef, { rounds: newRounds });
      console.log(`Verseny sikeresen hozzárendelve: ${newEventId}`);

      // --- ÚJ: ÉRTESÍTÉS KÜLDÉSE A TÖBBI SZERVEZŐNEK ---
      const event = allAvailableEvents.find(ev => ev.id === newEventId);
      await sendTournamentNotifications(tournament, "competition_assigned", {
        roundIndex: roundIndex,
        eventName: event?.competitionName || event?.title || "Ismeretlen verseny"
      });
    } catch (error) {
      console.error("Hiba a verseny hozzárendelésekor:", error);
      alert("Hiba történt a verseny mentése során!");
    }
  };

  // --- ÚJ: VERSENY ELTÁVOLÍTÁSA A FORDULÓBÓL ---
  const handleRemoveEventFromRound = async (tournament, roundIndex) => {
    if (!window.confirm("Biztosan lecsatolod ezt a versenyt a fordulóról?")) return;
    try {
      const tRef = doc(db, "tournaments", tournament.id);
      const newRounds = [...(tournament.rounds || [])];
      if (newRounds[roundIndex]) {
        newRounds[roundIndex].eventId = null;
        await updateDoc(tRef, { rounds: newRounds });
      }
    } catch (error) {
      console.error("Hiba a verseny lecsatolásakor:", error);
    }
  };

  // --- ÚJ: ELÉRHETŐ VERSENYEK LEKÉRÉSE ---
  const [allAvailableEvents, setAllAvailableEvents] = useState([]);

  useEffect(() => {
    if (tournaments.length === 0) return;

    const allOrgIds = new Set();
    tournaments.forEach(t => {
      t.organizers?.forEach(org => allOrgIds.add(org.id));
    });

    if (allOrgIds.size === 0) return;

    const q = query(collection(db, "events"));

    const unsubEvents = onSnapshot(q, (snap) => {
      const evs = [];
      snap.forEach(doc => {
        const data = doc.data();
        if (allOrgIds.has(data.organizerId)) {
          evs.push({ id: doc.id, ...data });
        }
      });
      setAllAvailableEvents(evs);
    });

    return () => unsubEvents();
  }, [tournaments]);

  useEffect(() => {
    if (!auth.currentUser) {
      setLoading(false);
      return;
    }

    // ÚJ: Olyan kupákat keresünk, ahol a bejelentkezett klub BÁRMELYIK szervező!
    // Ehhez az array-contains operátort kellene használnunk, de mivel objektumokat tárolunk, ez Firestore-ból trükkös.
    // Ehelyett lekérjük az összeset, aminek köze van hozzánk.
    // Valójában a legjobb megoldás, ha a backend (cloud function) vagy a mentés frissít egy string array-t is (pl. organizerIds).
    // Most a legegyszerűbb, ha létrehozunk egy speciális lekérdezést vagy bevezetünk egy organizerIds tömböt a kupa dokumentumban.
    // MIVEL MOST JAVÍTOTTUK AZ ADATMODELLT, TEGYÜK BELE AZ ID-KAT EGY KÜLÖN TÖMBBE A FIRESTORE-BA:

    // --- FIGYELEM! A lenti lekérdezés csak az "organizerId" (alapító) alapján keres.
    // Hogy a meghívottak is lássák, átmenetileg így kérjük le az összeset,
    // aminek ők is részei (majd kliens oldalon szűrünk).
    const q = query(
      collection(db, "tournaments")
      // Mivel a firestore nem tud objektum tömbben keresni egyszerűen,
      // később a mentésnél csinálunk egy sima string array-t is az ID-kkal.
    );

    const unsubscribe = onSnapshot(q, (querySnapshot) => {
      const serverTournaments = [];
      querySnapshot.forEach((doc) => {
        const data = doc.data();

        // Kliens oldali szűrés: Benne van-e a mi UID-nk az organizers tömbben ÉS active/owner a státuszunk?
        const amIOrganizing = data.organizers?.some(
          org => org.id === auth.currentUser.uid && (org.status === 'active' || org.status === 'owner')
        );

        // Visszafelé kompatibilitás: ha én vagyok az organizerId
        const amIOwner = data.organizerId === auth.currentUser.uid;

        if (amIOrganizing || amIOwner) {
          serverTournaments.push({ id: doc.id, ...data });
        }
      });
      setTournaments(serverTournaments);
      setLoading(false);
    }, (error) => {
      console.error("Hiba a kupasorozatok lekérésekor:", error);
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  if (loading) {
    return <div style={{ padding: '20px', color: '#b30000', fontWeight: 'bold' }}>Kupasorozatok betöltése...</div>;
  }

  return (
    <div style={{ width: '100%' }}>
      {/* MEGHÍVÓK SÁVJA (KUPASOROZATOK FÜLÖN BELÜL) */}
      {localPending.length > 0 && (
        <div style={{ marginBottom: '25px', display: 'flex', flexDirection: 'column', gap: '10px' }}>
          {localPending.map(inv => {
            // ÉRTESÍTÉS SZÖVEGEK TÍPUS ALAPJÁN
            let title = "Értesítés";
            let message = "";
            let icon = <FiAward />;
            let isActionable = inv.type === "tournament_invite";

            if (inv.type === "tournament_invite") {
              title = "Új Társrendezői Felkérés!";
              message = <>Meghívást kaptál a(z) <strong>{inv.tournamentName}</strong> kupasorozat szervezésébe.</>;
            } else if (inv.type === "tournament_invite_accepted") {
              title = "Új tag csatlakozott!";
              message = <><strong>{inv.fromUserName}</strong> elfogadta a meghívást a(z) <strong>{inv.tournamentName}</strong> kupasorozatba! 🤝</>;
              icon = <FiCheck />;
            } else if (inv.type === "competition_assigned") {
              title = "Verseny kijelölve!";
              message = <><strong>{inv.fromUserName}</strong> kijelölte a versenyt (<strong>{inv.eventName}</strong>) a(z) <strong>{inv.tournamentName}</strong> kupa {Number(inv.roundIndex) + 1}. fordulójához! 🏹</>;
              icon = <FiCalendar />;
            }

            return (
              <div key={inv.id} style={{
                backgroundColor: '#fffaf0', border: '1px solid #fbd38d', borderRadius: '10px',
                padding: '15px 20px', display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                boxShadow: '0 4px 6px rgba(0,0,0,0.05)'
              }}>
                <div>
                  <h4 style={{ margin: '0 0 5px 0', color: '#b7791f', display: 'flex', alignItems: 'center', gap: '8px' }}>
                    {icon} {title}
                  </h4>
                  <p style={{ margin: 0, fontSize: '0.9rem', color: '#666' }}>
                    {message}
                  </p>
                </div>
                <div style={{ display: 'flex', gap: '10px' }}>
                  {isActionable ? (
                    <>
                      <button onClick={() => rejectInvite(inv)} style={{ backgroundColor: '#fff', border: '1px solid #ccc', padding: '8px 15px', borderRadius: '8px', cursor: 'pointer', fontWeight: 'bold', color: '#666' }}>
                        Elutasít
                      </button>
                      <button onClick={() => acceptInvite(inv)} style={{ backgroundColor: '#28a745', border: 'none', padding: '8px 15px', borderRadius: '8px', cursor: 'pointer', fontWeight: 'bold', color: 'white', display: 'flex', alignItems: 'center', gap: '5px' }}>
                        <FiCheck /> Elfogad
                      </button>
                    </>
                  ) : (
                    <button
                      onClick={async () => {
                        try {
                          // --- ÚJ: Értesítés végleges törlése ---
                          await deleteDoc(doc(db, "notifications", inv.id));
                        } catch(e) { console.error("Hiba az értesítés törlésekor:", e); }
                      }}
                      style={{ backgroundColor: '#fff', border: '1px solid #ccc', padding: '8px 15px', borderRadius: '8px', cursor: 'pointer', fontWeight: 'bold', color: '#666' }}
                    >
                      Értem
                    </button>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      )}

      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '25px', borderBottom: '1px solid #eee', paddingBottom: '10px' }}>
        <h2 style={{ color: '#b30000', margin: 0 }}>
          Kupasorozatok
        </h2>

        <button
          style={createButtonStyle}
          onClick={() => navigate('/kupasorozat-letrehozas')}
        >
          <FiPlus size={20} />
          <span>Új kupasorozat létrehozása</span>
        </button>
      </div>

      <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
        {tournaments.length > 0 ? (
          tournaments.map((tournament) => {
            const isExpanded = expandedTournamentId === tournament.id;

            return (
              <div key={tournament.id} style={{ display: 'flex', flexDirection: 'column' }}>

                <div
                  style={accordionHeaderStyle(isExpanded)}
                  onClick={() => setExpandedTournamentId(isExpanded ? null : tournament.id)}
                >
                  <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
                    <span style={{
                      backgroundColor: '#e6fffa', color: '#2c7a7b', padding: '4px 10px',
                      borderRadius: '20px', fontSize: '11px', fontWeight: 'bold', border: '1px solid #b2f5ea'
                    }}>
                      {tournament.status || 'Aktív'}
                    </span>
                    <h4 style={{ margin: 0, fontSize: '18px', color: '#333' }}>{tournament.name || "Névtelen Kupa"}</h4>
                    <span style={{ fontSize: '13px', color: '#888', backgroundColor: '#f0f0f0', padding: '2px 8px', borderRadius: '6px' }}>
                      {tournament.roundCount || 0} forduló
                    </span>
                  </div>

                  <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
                    <div style={{ display: 'flex', gap: '10px' }} onClick={(e) => e.stopPropagation()}>
                      <FiEdit2
                        style={{ cursor: 'pointer', color: '#666' }}
                        title="Alapadatok szerkesztése"
                        onClick={() => navigate(`/kupasorozat-szerkesztes/${tournament.id}`)}
                      />
                      <FiTrash2
                        style={{ cursor: 'pointer', color: '#b30000' }}
                        title="Törlés"
                        onClick={() => openDeleteModal(tournament)}
                      />
                    </div>
                    <div style={{
                      width: '32px', height: '32px', borderRadius: '50%', backgroundColor: isExpanded ? '#b30000' : '#f0f0f0',
                      display: 'flex', alignItems: 'center', justifyContent: 'center', color: isExpanded ? '#fff' : '#666',
                      transition: 'all 0.2s ease'
                    }}>
                      {isExpanded ? <FiChevronUp size={20} /> : <FiChevronDown size={20} />}
                    </div>
                  </div>
                </div>

                {isExpanded && (
                  <div style={accordionBodyStyle} className="fade-in-down">
                    <h4 style={{ margin: '0 0 20px 0', color: '#b30000', borderBottom: '2px solid #eee', paddingBottom: '10px' }}>
                      Fordulók kezelése
                    </h4>

                    <div style={{
                      display: 'flex',
                      gap: '20px',
                      overflowX: 'auto',
                      paddingBottom: '15px'
                    }}>
                      {Array.from({ length: tournament.roundCount || 1 }, (_, index) => (
                        <div key={index} style={{
                          backgroundColor: '#fafafa',
                          border: '1px solid #ddd',
                          borderRadius: '12px',
                          padding: '15px',
                          display: 'flex',
                          flexDirection: 'column',
                          gap: '15px',
                          minWidth: '280px',
                          flex: '0 0 auto'
                        }}>
                          <div style={{ fontWeight: 'bold', color: '#333', fontSize: '1.1rem', textAlign: 'center' }}>
                            {index + 1}. Forduló
                          </div>

                          <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                            <label style={{ fontSize: '0.8rem', fontWeight: 'bold', color: '#666', textTransform: 'uppercase' }}>
                              Szervező Egyesület
                            </label>
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                              {auth.currentUser?.uid === tournament.organizerId ? (
                                <select
                                  style={{
                                    width: '100%',
                                    padding: '8px 10px',
                                    borderRadius: '8px',
                                    border: '1px solid #ccc',
                                    backgroundColor: '#fff',
                                    fontSize: '0.9rem',
                                    cursor: 'pointer'
                                  }}
                                  value={selectedRoundOrgs[`${tournament.id}_${index}`] || (tournament.rounds && tournament.rounds[index] ? tournament.rounds[index].organizerId : (tournament.organizers?.[0]?.id || ""))}
                                  onChange={(e) => {
                                    handleRoundOrganizerChange(tournament, index, e.target.value);
                                  }}
                                >
                                  {tournament.organizers && tournament.organizers.map((org, oIdx) => (
                                    <option key={oIdx} value={org.id}>
                                      {org.name} {org.status === 'pending' ? '(Meghívásra vár)' : ''}
                                    </option>
                                  ))}
                                </select>
                              ) : (
                                <div style={{
                                  padding: '8px 10px',
                                  backgroundColor: '#f8f9fa',
                                  borderRadius: '8px',
                                  border: '1px solid #eee',
                                  fontSize: '0.9rem',
                                  color: '#333',
                                  fontWeight: 'bold'
                                }}>
                                  {tournament.organizers?.find(o => o.id === (tournament.rounds?.[index]?.organizerId || tournament.organizers?.[0]?.id))?.name || "Nincs kijelölve"}
                                </div>
                              )}

                              {/* DINAMIKUS MEGHÍVÁS GOMB - CSAK A TULAJDONOSNAK */}
                              {auth.currentUser?.uid === tournament.organizerId && (() => {
                                // JAVÍTÁS: A gomb logikája konzisztensen nézi az állapotot és az adatbázist
                                const currentOrgId = selectedRoundOrgs[`${tournament.id}_${index}`] ||
                                                   (tournament.rounds && tournament.rounds[index] ? tournament.rounds[index].organizerId : tournament.organizers?.[0]?.id);

                                const selectedOrg = tournament.organizers?.find(o => o.id === currentOrgId);

                                if (selectedOrg && selectedOrg.status !== 'owner') {
                                  return (
                                    <button
                                      onClick={() => handleSendInvite(selectedOrg, tournament)}
                                      disabled={isSendingInvite || selectedOrg.status === 'active'}
                                      style={{
                                        backgroundColor: selectedOrg.status === 'active' ? '#28a745' : '#b30000',
                                        color: 'white',
                                        border: 'none',
                                        padding: '8px 12px',
                                        borderRadius: '8px',
                                        fontSize: '0.85rem',
                                        fontWeight: 'bold',
                                        cursor: (isSendingInvite || selectedOrg.status === 'active') ? 'not-allowed' : 'pointer',
                                        boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
                                        width: '100%',
                                        opacity: (isSendingInvite || selectedOrg.status === 'active') ? 0.7 : 1,
                                        marginTop: '5px'
                                      }}
                                      title={selectedOrg.status === 'active' ? "Már elfogadta a meghívást" : "Meghívó küldése a szervezőnek"}
                                    >
                                      {selectedOrg.status === 'active' ? '✅ Csatlakozott' : (isSendingInvite ? 'Küldés...' : 'Meghívás küldése')}
                                    </button>
                                  );
                                }
                                return null;
                              })()}
                            </div>
                          </div>

                          <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                            <label style={{ fontSize: '0.8rem', fontWeight: 'bold', color: '#666', textTransform: 'uppercase' }}>
                              Hozzárendelt Verseny
                            </label>

                            {(() => {
                              const currentRound = tournament.rounds?.[index];
                              const assignedEventId = currentRound?.eventId;
                              const assignedEvent = allAvailableEvents.find(ev => ev.id === assignedEventId);
                              const isImported = currentRound?.isImported;

                              // ÚJ: JOGOSULTSÁG ELLENŐRZÉSE
                              const roundOrganizerId = currentRound?.organizerId || tournament.organizers?.[0]?.id;
                              const isMyRound = auth.currentUser?.uid === roundOrganizerId;

                              if (assignedEvent) {
                                // ... meglévő kód a verseny megjelenítéséhez ...
                                return (
                                  <div style={{
                                    backgroundColor: '#fff',
                                    border: '1px solid #28a745',
                                    borderRadius: '10px',
                                    padding: '12px',
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    boxShadow: '0 2px 4px rgba(40, 167, 69, 0.1)'
                                  }}>
                                    <div style={{ display: 'flex', flexDirection: 'column', gap: '3px' }}>
                                      <span style={{ fontWeight: 'bold', fontSize: '0.95rem', color: '#333' }}>
                                        {assignedEvent.competitionName || assignedEvent.title}
                                      </span>
                                      <span style={{ fontSize: '0.8rem', color: '#666', display: 'flex', alignItems: 'center', gap: '5px' }}>
                                        <FiCalendar size={12} /> {assignedEvent.competitionDate}
                                      </span>
                                    </div>

                                    {isMyRound && (
                                      <button
                                        onClick={() => handleRemoveEventFromRound(tournament, index)}
                                        style={{ background: 'none', border: 'none', color: '#b30000', cursor: 'pointer', padding: '5px', display: 'flex', alignItems: 'center' }}
                                        title="Verseny lecsatolása"
                                      >
                                        <FiTrash2 size={18} />
                                      </button>
                                    )}
                                  </div>
                                );
                              }

                              if (isImported) {
                                return (
                                  <div style={{
                                    backgroundColor: '#fff5f5',
                                    border: '1px solid #b30000',
                                    borderRadius: '10px',
                                    padding: '12px',
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center'
                                  }}>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                      <FiInbox color="#b30000" size={20} />
                                      <div style={{ display: 'flex', flexDirection: 'column' }}>
                                        <span style={{ fontWeight: 'bold', fontSize: '0.9rem', color: '#b30000' }}>Eredmények importálva</span>
                                        <span style={{ fontSize: '0.75rem', color: '#666' }}>Excel / TSV forrás</span>
                                      </div>
                                    </div>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                      {isMyRound && (
                                        <>
                                          <button
                                            onClick={() => handleViewImport(tournament, index)}
                                            style={{ background: 'none', border: 'none', color: '#666', cursor: 'pointer', padding: '5px', display: 'flex', alignItems: 'center' }}
                                            title="Adatok ellenőrzése"
                                          >
                                            <FiEye size={18} />
                                          </button>
                                          <button
                                            onClick={() => handleRemoveImport(tournament, index)}
                                            style={{ background: 'none', border: 'none', color: '#b30000', cursor: 'pointer', padding: '5px', display: 'flex', alignItems: 'center' }}
                                            title="Importált adatok törlése"
                                          >
                                            <FiTrash2 size={18} />
                                          </button>
                                        </>
                                      )}
                                    </div>
                                  </div>
                                );
                              }

                              // HA NINCS VERSENY ÉS Ő A SZERVEZŐ -> MUTATJUK A GOMBOKAT
                              if (isMyRound) {
                                return (
                                  <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                                    <button
                                      onClick={() => {
                                        setPickingFor({ tournament, roundIndex: index });
                                        setShowEventPicker(true);
                                      }}
                                      style={actionButtonStyle('#f8f9fa', '#333', '#ddd')}
                                    >
                                      <FiPlus size={16} /> Meglévő verseny hozzáadása
                                    </button>

                                    <button
                                      onClick={() => navigate('/verseny-letrehozas', {
                                        state: {
                                          fromTournament: {
                                            id: tournament.id,
                                            name: tournament.name,
                                            roundIndex: index,
                                            organizerId: roundOrganizerId
                                          }
                                        }
                                      })}
                                      style={actionButtonStyle('#f8f9fa', '#333', '#ddd')}
                                    >
                                      <FiEdit2 size={16} /> Új verseny létrehozása
                                    </button>

                                    <button
                                      onClick={() => {
                                        setImportingFor({ tournament, roundIndex: index });
                                        setShowImportModal(true);
                                        setImportStep(1);
                                      }}
                                      style={actionButtonStyle('#f8f9fa', '#333', '#ddd')}
                                    >
                                      <FiInbox size={16} /> Csak eredmények (excel import)
                                    </button>
                                  </div>
                                );
                              }

                              // HA NEM Ő A SZERVEZŐ -> CSAK INFÓ
                              const organizerName = tournament.organizers?.find(o => o.id === roundOrganizerId)?.name || "Másik egyesület";
                              return (
                                <div style={{
                                  padding: '15px',
                                  backgroundColor: '#f0f0f0',
                                  borderRadius: '10px',
                                  color: '#666',
                                  fontSize: '0.85rem',
                                  textAlign: 'center',
                                  border: '1px dashed #ccc'
                                }}>
                                  Ezt a fordulót a(z) <strong>{organizerName}</strong> kezeli.
                                </div>
                              );
                            })()}

                            {/* Ha nincs a szervezőnek versenye a rendszerben */}
                            {allAvailableEvents.filter(ev => ev.organizerId === (tournament.rounds?.[index]?.organizerId || tournament.organizers?.[0]?.id)).length === 0 && !tournament.rounds?.[index]?.eventId && (
                              <p style={{ fontSize: '0.75rem', color: '#b30000', margin: '0', fontStyle: 'italic' }}>
                                Ennek a szervezőnek még nincs létrehozott versenye.
                              </p>
                            )}
                          </div>

                        </div>
                      ))}
                    </div>

                    {/* --- ÚJ: KUPASOROZAT ÖSSZESÍTÉSE GOMB --- */}
                    <div style={{
                      marginTop: '30px',
                      paddingTop: '20px',
                      borderTop: '2px solid #eee',
                      display: 'flex',
                      justifyContent: 'center'
                    }}>
                      <button
                        onClick={() => navigate(`/kupasorozat-osszesites/${tournament.id}`)}
                        style={{
                          backgroundColor: '#b30000', // ArcheryNexus piros
                          color: 'white',
                          border: 'none',
                          padding: '12px 30px',
                          borderRadius: '12px',
                          fontWeight: 'bold',
                          cursor: 'pointer',
                          display: 'flex',
                          alignItems: 'center',
                          gap: '10px',
                          fontSize: '16px',
                          boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
                          transition: 'all 0.2s ease'
                        }}
                        onMouseOver={e => e.currentTarget.style.backgroundColor = '#990000'}
                        onMouseOut={e => e.currentTarget.style.backgroundColor = '#b30000'}
                      >
                        <FiAward size={20} />
                        Kupasorozat összesítése
                      </button>
                    </div>

                  </div>
                )}
              </div>
            );
          })
        ) : (
          <div style={emptyStateStyle}>
            <FiAward size={50} style={{ marginBottom: '15px', color: '#ccc' }} />
            <p style={{ margin: 0, fontWeight: 'bold', color: '#888' }}>
              Még nincsenek kupasorozataid.
            </p>
            <p style={{ fontSize: '14px', color: '#aaa' }}>Kattints az "Új kupasorozat létrehozása" gombra!</p>
          </div>
        )}
      </div>

      {showDeleteModal && (
        <div style={modalOverlayStyle}>
          <div style={modalContentStyle}>
            <FiAlertTriangle size={50} color="#b30000" style={{ marginBottom: '15px' }} />
            <h3 style={{ margin: '0 0 10px 0', color: '#333' }}>Biztosan törölni szeretnéd?</h3>
            <p style={{ color: '#666', marginBottom: '25px', lineHeight: '1.5' }}>
              Valóban törölni szeretnéd a(z) <br/>
              <strong>{tournamentToDelete?.name || "Névtelen"}</strong> <br/>
              kupasorozatot?
              <br/><br/>
              <span style={{ fontSize: '0.8rem', color: '#b30000' }}>
                *A kupához tartozó versenyek <strong>nem</strong> törlődnek a rendszerből, csak lecsatolódnak a sorozatról.
              </span>
            </p>
            <div style={{ display: 'flex', gap: '15px', justifyContent: 'center' }}>
              <button style={modalCancelButtonStyle} onClick={() => setShowDeleteModal(false)}>Mégse</button>
              <button style={modalDeleteButtonStyle} onClick={handleFinalDelete}>Igen, törlöm</button>
            </div>
          </div>
        </div>
      )}

      {/* --- ÚJ: VERSENYVÁLASZTÓ MODAL --- */}
      {showEventPicker && pickingFor && (
        <div style={modalOverlayStyle} onClick={() => setShowEventPicker(false)}>
          <div style={{ ...modalContentStyle, maxWidth: '600px', textAlign: 'left' }} onClick={e => e.stopPropagation()}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px', borderBottom: '2px solid #eee', paddingBottom: '10px' }}>
              <h3 style={{ margin: 0, color: '#b30000' }}>Válassz egy meglévő versenyt</h3>
              <FiPlus style={{ transform: 'rotate(45deg)', cursor: 'pointer' }} size={24} onClick={() => setShowEventPicker(false)} />
            </div>

            <div style={{ maxHeight: '400px', overflowY: 'auto', display: 'flex', flexDirection: 'column', gap: '10px' }}>
              {(() => {
                const currentOrgId = pickingFor.tournament.rounds?.[pickingFor.roundIndex]?.organizerId || pickingFor.tournament.organizers?.[0]?.id;
                const filteredEvents = allAvailableEvents.filter(ev => ev.organizerId === currentOrgId);

                if (filteredEvents.length === 0) {
                  return <p style={{ textAlign: 'center', color: '#888', padding: '20px' }}>Ennek a szervezőnek nincs elérhető versenye.</p>;
                }

                return filteredEvents.map(ev => (
                  <div
                    key={ev.id}
                    onClick={() => {
                      handleRoundEventChange(pickingFor.tournament, pickingFor.roundIndex, ev.id);
                      setShowEventPicker(false);
                    }}
                    style={{
                      padding: '12px 15px',
                      borderRadius: '10px',
                      border: '1px solid #eee',
                      cursor: 'pointer',
                      transition: '0.2s',
                      backgroundColor: '#f9f9f9',
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center'
                    }}
                    onMouseOver={e => e.currentTarget.style.borderColor = '#b30000'}
                    onMouseOut={e => e.currentTarget.style.borderColor = '#eee'}
                  >
                    <div>
                      <div style={{ fontWeight: 'bold', color: '#333' }}>{ev.competitionName || ev.title}</div>
                      <div style={{ fontSize: '0.8rem', color: '#666' }}>{ev.competitionDate} • {ev.location}</div>
                    </div>
                    <FiPlus color="#b30000" />
                  </div>
                ));
              })()}
            </div>
          </div>
        </div>
      )}

      {/* --- ÚJ: EXCEL IMPORT MODAL --- */}
      {showImportModal && (
        <div style={modalOverlayStyle} onClick={() => !isProcessingExcel && setShowImportModal(false)}>
          <div style={{ ...modalContentStyle, maxWidth: '600px', textAlign: 'left' }} onClick={e => e.stopPropagation()}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px', borderBottom: '2px solid #eee', paddingBottom: '10px' }}>
              <h3 style={{ margin: 0, color: '#b30000' }}>Eredmények importálása ({importingFor?.roundIndex + 1}. forduló)</h3>
              <FiPlus style={{ transform: 'rotate(45deg)', cursor: 'pointer' }} size={24} onClick={() => setShowImportModal(false)} />
            </div>

            {importStep === 1 ? (
              <div style={{ textAlign: 'center', padding: '30px 0' }}>
                <FiInbox size={50} color="#ccc" style={{ marginBottom: '20px' }} />
                <p style={{ color: '#666', marginBottom: '25px' }}>Válassz ki egy .xlsx vagy .csv fájlt az eredményekkel.</p>

                <label style={{
                  backgroundColor: '#b30000', color: 'white', padding: '12px 30px',
                  borderRadius: '10px', fontWeight: 'bold', cursor: 'pointer', display: 'inline-block'
                }}>
                  {isProcessingExcel ? 'Feldolgozás...' : 'Fájl kiválasztása'}
                  <input type="file" accept=".xlsx, .xls, .csv" style={{ display: 'none' }} onChange={handleFileUpload} disabled={isProcessingExcel} />
                </label>
              </div>
            ) : (
              <div>
                {autoMatchFound ? (
                  <div style={{ textAlign: 'center', padding: '20px 0' }}>
                    <div style={{ backgroundColor: '#e6fffa', color: '#2c7a7b', padding: '20px', borderRadius: '12px', marginBottom: '25px', border: '1px solid #b2f5ea' }}>
                      <FiCheck size={40} style={{ marginBottom: '10px' }} />
                      <h4 style={{ margin: '0 0 10px 0' }}>Sikeres beolvasás!</h4>
                      <p style={{ margin: 0, fontSize: '1.1rem' }}>
                        Találtam <strong>{excelRows.length}</strong> érvényes eredményt a fájlban.
                      </p>
                    </div>
                    <p style={{ fontSize: '0.9rem', color: '#666', marginBottom: '20px' }}>
                      Minden kötelező adatot (Név, Pontok) sikerült automatikusan azonosítani.
                    </p>
                  </div>
                ) : (
                  <div style={{ textAlign: 'center', padding: '20px 0' }}>
                    <div style={{ backgroundColor: '#fff5f5', color: '#c53030', padding: '20px', borderRadius: '12px', marginBottom: '25px', border: '1px solid #feb2b2' }}>
                      <FiAlertTriangle size={40} style={{ marginBottom: '10px' }} />
                      <h4 style={{ margin: '0 0 10px 0' }}>Beolvasási hiba!</h4>
                      <p style={{ margin: 0, fontSize: '1rem' }}>
                        Nem találom a <strong>NÉV</strong> vagy <strong>Pontok</strong> oszlopot a fájlban.
                      </p>
                    </div>
                    <p style={{ fontSize: '0.85rem', color: '#666', marginBottom: '20px', lineHeight: '1.5' }}>
                      Kérlek ellenőrizd az Excel fájl első sorát!<br/>
                      Az oszlopok nevei között szerepelnie kell: <strong>NÉV</strong> és <strong>Pontok</strong>.
                    </p>
                  </div>
                )}

                <div style={{ marginTop: '30px', display: 'flex', gap: '15px' }}>
                  <button
                    onClick={() => { setImportStep(1); setAutoMatchFound(false); }}
                    style={{ flex: 1, padding: '12px', borderRadius: '8px', border: '1px solid #ccc', backgroundColor: '#fff', cursor: 'pointer', fontWeight: 'bold' }}
                  >
                    Mégse / Új fájl
                  </button>
                  {autoMatchFound && (
                    <button
                      onClick={handleSaveImport}
                      style={{ flex: 2, padding: '12px', borderRadius: '8px', border: 'none', backgroundColor: '#28a745', color: '#fff', cursor: 'pointer', fontWeight: 'bold' }}
                    >
                      Igen, adatok mentése
                    </button>
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
      )}

      {/* --- ÚJ: IMPORTÁLT ADATOK MEGTEKINTÉSE MODAL --- */}
      {showViewModal && (
        <div style={modalOverlayStyle} onClick={() => setShowViewModal(false)}>
          <div style={{ ...modalContentStyle, maxWidth: '800px', textAlign: 'left' }} onClick={e => e.stopPropagation()}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px', borderBottom: '2px solid #eee', paddingBottom: '10px' }}>
              <h3 style={{ margin: 0, color: '#b30000' }}>Importált eredmények ellenőrzése</h3>
              <FiPlus style={{ transform: 'rotate(45deg)', cursor: 'pointer' }} size={24} onClick={() => setShowViewModal(false)} />
            </div>

            {isFetchingResults ? (
              <p style={{ textAlign: 'center', padding: '20px', color: '#888' }}>Adatok betöltése...</p>
            ) : (
              <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
                <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                  <thead>
                    <tr style={{ borderBottom: '2px solid #eee', textAlign: 'left' }}>
                      <th style={{ padding: '10px', fontSize: '0.75rem', color: '#666' }}>#</th>
                      <th style={{ padding: '10px', fontSize: '0.75rem', color: '#666' }}>NÉV</th>
                      <th style={{ padding: '10px', fontSize: '0.75rem', color: '#666' }}>KATEGÓRIA</th>
                      <th style={{ padding: '10px', fontSize: '0.75rem', color: '#666' }}>KOR</th>
                      <th style={{ padding: '10px', fontSize: '0.75rem', color: '#666' }}>NEM</th>
                      <th style={{ padding: '10px', fontSize: '0.75rem', color: '#666', textAlign: 'center' }}>PONTOK</th>
                    </tr>
                  </thead>
                  <tbody>
                    {viewingResults.length > 0 ? viewingResults.map((r, i) => (
                      <tr key={i} style={{ borderBottom: '1px solid #f9f9f9' }}>
                        <td style={{ padding: '10px', fontSize: '0.8rem', color: '#888' }}>{i + 1}.</td>
                        <td style={{ padding: '10px', fontSize: '0.85rem', fontWeight: 'bold' }}>{r.name}</td>
                        <td style={{ padding: '10px', fontSize: '0.8rem', color: '#555' }}>{r.category || "-"}</td>
                        <td style={{ padding: '10px', fontSize: '0.8rem', color: '#555' }}>{r.ageGroup || "-"}</td>
                        <td style={{ padding: '10px', fontSize: '0.8rem', color: '#555' }}>{r.gender || "-"}</td>
                        <td style={{ padding: '10px', fontSize: '0.85rem', textAlign: 'center', color: '#b30000', fontWeight: 'bold' }}>{r.points}</td>
                      </tr>
                    )) : (
                      <tr>
                        <td colSpan="6" style={{ textAlign: 'center', padding: '20px', color: '#999' }}>Nincsenek adatok.</td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            )}

            <div style={{ marginTop: '20px', textAlign: 'right' }}>
              <button
                onClick={() => setShowViewModal(false)}
                style={{ padding: '10px 25px', borderRadius: '8px', border: 'none', backgroundColor: '#eee', cursor: 'pointer', fontWeight: 'bold' }}
              >
                Bezárás
              </button>
            </div>
          </div>
        </div>
      )}

      <style>{`
        .fade-in-down {
          animation: fadeInDown 0.3s ease-out;
          transform-origin: top;
        }
        @keyframes fadeInDown {
          0% { opacity: 0; transform: translateY(-10px) scaleY(0.95); }
          100% { opacity: 1; transform: translateY(0) scaleY(1); }
        }
      `}</style>
    </div>
  );
};

export default Tournaments;
